<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Merchant Report"
              bc1="App"
              bc2="Merchant Report"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- users list start -->
        <section class="app-user-list">
          <div class="card">
            <h5 class="card-header">Filters</h5>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Select Type</label>
                      <select
                          @change="handleSingleTypeChange"
                          class="form-control"
                          v-model="type"
                      >
                        <option
                            :key="typeIndex"
                            :value="typeVal.value"
                            v-for="(typeVal, typeIndex) in typeList"
                        >
                          {{typeVal.label}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1" v-show="showSettlementDropdown">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Settlement</label>
                      <InfiniteSelect
                          api-url="v1/get-settlement"
                          ref="settlementInfiniteSelect"
                          :request-params="requestParams"
                          :formatter="customSettlementNameForMultiselect"
                          key-field="id"
                          @selectedFullObj="(item) => selectedSettlement = item"
                          placeholder-text="Select a settlement..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1" v-if="type == 'vat' || type == 'storeSettlementReport'">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Store</label>
                      <InfiniteSelect
                          api-url="v1/get-store"
                          ref="storeInfiniteSelect"
                          :request-params="storeRequestParams"
                          :formatter="(obj) => obj.name + '/' + obj.code"
                          key-field="id"
                          @selectedFullObj="(item) => selectedStore = item"
                          placeholder-text="Select a store..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Select Status</label>
                      <select class="form-control" v-model="selectedStatus">
                        <option :value="null">Select Status</option>
                        <option :value="0">Generating</option>
                        <option :value="1">Success</option>
                        <option :value="2">Failed</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1" v-show="type == 'vat'">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Invoice Number</label>
                      <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="searchInvoiceNumber" placeholder="Search here..."/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1 mt-2">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <date-picker
                          v-model="reportGeneratedDate"
                          :disabledDate="disableFutureDates"
                          valueType="format"
                          :lang="lang"
                          name="reportGeneratedDate"
                          placeholder="Choose Report Date"
                          class="w-100"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_status">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
              </div>

            </div>
          </div>
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-6 col-12">
                  <label>Report Type</label>
                  <select
                      @change="handleSingleTypeChange"
                      class="form-control"
                      v-model="type"
                  >
                    <option
                        :key="typeIndex"
                        :value="typeVal.value"
                        v-for="(typeVal, typeIndex) in typeList"
                    >
                      {{typeVal.label}}
                    </option>
                  </select>
                </div>
                <div class="col-md-6 col-12">
                  <div class="d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="$router.push({ name: 'generate-merchant-report' })"
                    >
                      <span class="text-nowrap">Generate Report</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <CommonTable
                  :url="url"
                  :tableHeaderValues="tableHeaderValues"
                  :actions="actions"
                  :deleteActions="deleteActions"
                  :mutedData="mutedData"
                  :storageKey="storageKey"
                  :externalTotalRecord="externalTotalRecord"
                  :filteredData="filteredData"
                  :showPerPage="true"
              />
            </div>
          </div>
        </section>

      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" @confirm="resendConfirmCallback" message="Are you sure to resend the report?"
                       title="Resend"
                       @hide="showConfirmationModal = false"></ConfirmationModal>
    <DetailsModal    :data="detailsModalData"
                               :show="showDetailsModal"
                               @hide="showDetailsModal = false"
    ></DetailsModal>
  </div>
</template>

<script>


import InfiniteSelect from "@/components/common/InfiniteSelect.vue";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import merchantReportMixin from "./merchantReportMixin";
import DetailsModal from "@/pages/dashboard/merchant-report/DetailsModal.vue";

export default {
  components:{
    DetailsModal,
    InfiniteSelect,
    DatePicker
  },
  mounted() {
    localStorage.setItem("url", "v1/all-reports");
    this.checkDataInStore('v1/all-reports')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  mixins: [merchantReportMixin],
  data() {
    return {
      searchInvoiceNumber:'',
      showDetailsModal:false,
      detailsModalData:[],
      selectedRow: null,
      showConfirmationModal: false,
      selectedStatus: null,
      reportGeneratedDate: null,
      tableHeaderValues: [
        {
          title: 'Type',
          valueKey: 'type',
          html: true,
          alter: function(value,row) {
            var html=''
            if(value) {
              if (value == 1){
                html = `<div class="badge badge-light-primary">Settlement</div>`
              }else if(value == 2){
                html = `<div class="badge badge-light-primary">Vat</div>`
              }
              else if(value == 3){
                html = `<div class="badge badge-light-primary">ExtraMiles Split Report</div>`
              }
              else if(value == 4){
                html = `<div class="badge badge-light-primary">Euronet DCC Report</div>`
              }
              else if(value == 5){
                html = `<div class="badge badge-light-primary">Settlement For Store</div>`
              }
              else {
                html = `<div class="badge badge-light-primary">N/A</div>`
              }
            }
            return  html


          }
        },
        {
          title: 'reference',
          valueKey: 'type',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value && row.settlement){
              html = `<div class="badge text-dark font-small-1">${row.settlement.uuid}</div>`
            }
            if(value && (value == 2 || value == 5) && row.store){
              html = `<div class="badge text-dark font-small-1">${row.store.name}/${row.store.code}</div>`
            }

            return  html
          }
        },
        {
          title: 'Invoice Number',
          valueKey: 'number',
          html: true,
          alter:  (value,row) => {
            var html = '-'
            if (value){
              html = `<div class="badge badge-pill font-small-1 mb-1 badge-glow badge-light-dark">INV${value}</div>`
            }

            if(row.period){
              if(!value){
                html = ''
              }

              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-success font-small-1 ">${this.formatMonthFromAPI(row.period)}</div>
                    </div>
                </div>
                `
            }

            if(row.from_date && row.to_date){
              if(!value){
                html = ''
              }

              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-success font-small-1 ">${this.customFormatDateTime(row.from_date)} - ${this.customFormatDateTime(row.to_date)}</div>
                    </div>
                </div>
                `
            }

            return html

          }
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter: function(value,row) {
            var html=''
            if (value == 0)
              html = `<div class="badge badge-glow badge-info">Generating</div>`
            else if (value == 2)
              html = `<div class="badge badge-glow badge-danger">Failed</div>`
            else if (value == 1)
              html = `<div class="badge badge-glow badge-success">Success</div>`


            return  html
          }
        },
        {
          title: 'Created At',
          valueKey: 'created_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
        {
          title: 'Updated At',
          valueKey: 'updated_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
      ],
      actions: [
        {
          title: 'Resend',
          // conditionalRendering: true,
          // condition: (row)=>{
          //   if(row.status  == 0 ){
          //     return false
          //   }
          //   return true
          // },
          class: 'btn-warning btn-sm badge',
          cta: (row,index) => {
            this.selectedRow = row
            this.showConfirmationModal = true
          }
        },
        {
          title: 'Details',
          class: 'btn-primary btn-sm badge mr-1',
          cta: (row,index) => {
            this.detailsModalData = []
            if(row.report_details && row.report_details.length>0){
              this.detailsModalData = row.report_details
            }
            this.showDetailsModal = true
          }
        },
      ],
      url: "v1/all-reports",
      storageKey: "merchant-report",
      mutedData: [],
      deleteActions: [],
      externalTotalRecord: "",
      filteredData: {type:'settlement'},

    }
  },
  methods: {
    handleSingleTypeChange(event){
      this.filteredData = {
        type: event.target.value
      }
    },
    resendConfirmCallback(){
      this.$store.dispatch('exportExcelLoader', true)
      let data = {}

      if(this.selectedRow.type == 1){
        data.type = 'settlement'
        data.typeId = this.selectedRow.type_id
      }else if(this.selectedRow.type == 2){
        data.type = 'vat'
        data.typeId = this.selectedRow.type_id
        data.period = this.selectedRow.period
      }else if(this.selectedRow.type == 3){
        data.type = 'extraMilesSplitReport'
        data.period = this.selectedRow.period
      }
      else if(this.selectedRow.type == 4){
        data.type = 'euronetDccReport'
        data.typeId = this.selectedRow.type_id
        data.fromDate = this.selectedRow.from_date
        data.toDate = this.selectedRow.to_date
      }
      else if(this.selectedRow.type == 5){
        data.type = 'storeSettlementReport'
        data.typeId = this.selectedRow.type_id
        data.fromDate = this.selectedRow.from_date
        data.toDate = this.selectedRow.to_date
      }

      this.makeRequest("post", "v1/merchant-report", data).then(
          (callResponse) => {
            this.$store.dispatch('exportExcelLoader', false)
            this.showConfirmationModal = false
            this.onSubmitFilters()
          }
      );
    },
    onSubmitFilters() {

      let filterData = {}

      if(this.type != ''){
        filterData.type = this.type
      }

      if(this.selectedStatus != null){
        filterData.status = this.selectedStatus
      }

      if(this.searchInvoiceNumber != ''){
        filterData.number = this.searchInvoiceNumber
      }

      if(this.reportGeneratedDate != null && this.reportGeneratedDate != ''){
        filterData.reportGeneratedDate = this.reportGeneratedDate
      }

      if(this.type == 'settlement' && this.selectedSettlement){
        filterData.typeId = this.selectedSettlement.id
      }

      else if(this.type == 'vat' && this.selectedStore){
        filterData.typeId = this.selectedStore.id
      }

      else if(this.type == 'storeSettlementReport' && this.selectedStore){
        filterData.typeId = this.selectedStore.id
      }

      this.filteredData = filterData


    },
    clear(){
      this.selectedStatus = null
      // this.$refs.storeInfiniteSelect.clearSearch();
      this.$refs.settlementInfiniteSelect.clearSearch();
      this.type = 'settlement'
      this.selectedSettlement = null
      this.selectedStore = null
      this.searchInvoiceNumber = ''
      this.reportGeneratedDate = null
      this.filteredData = {type:'settlement'}
    },
  },

}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>

